/** @type {import("@mui/material").SxProps<Theme>} */

const styles = theme => ({
  loaderText: {
    color: theme.palette.secondary.contrastText,
  },
  loaderButton: {
    border: `0.063rem solid ${theme.palette.primary.textColor2}`,
    padding: '0.3125rem',
    fontFamily: theme.typography.subtitle1.fontFamily,
    background: theme.palette.primary.buttonColor,
    color: theme.palette.primary.contrastText,

    '&:hover': {
      border: `0.063rem solid ${theme.palette.primary.textColor2}`,
      background: theme.palette.primary.buttonPrimaryHoverColor,
      color: theme.palette.primary.contrastText,
    },
  },
});

export default styles;
